export default "__VITE_ASSET__tfosO6eR__"